class DefaultStorageProvider {
  loadUserSetting(namespace, key) {
    const storageValue = localStorage.getItem(`${namespace}:${key}`);
    return storageValue !== null && storageValue !== void 0 ? storageValue : null;
  }
  saveUserSetting(namespace, key, value) {
    localStorage.setItem(`${namespace}:${key}`, value.toString());
  }
  removeUserSetting(namespace, key) {
    localStorage.removeItem(`${namespace}:${key}`);
  }
}

export { DefaultStorageProvider as default };
